import { render } from "./FieldKFactor.vue?vue&type=template&id=10323222"
import script from "./FieldKFactor.vue?vue&type=script&lang=js"
export * from "./FieldKFactor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__